export const formatDate = (iso) => {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export const formatCount = (value) => (Number(value) || 0).toLocaleString()

export const formatDuration = (startedAt, finishedAt, now = Date.now()) => {
  if (!startedAt) return '—'
  const from = new Date(startedAt).getTime()
  const to = finishedAt ? new Date(finishedAt).getTime() : now
  if (Number.isNaN(from) || Number.isNaN(to) || to < from) return '—'
  const totalSec = Math.floor((to - from) / 1000)
  const hours = Math.floor(totalSec / 3600)
  const minutes = Math.floor((totalSec % 3600) / 60)
  const seconds = totalSec % 60
  if (hours > 0) return `${hours}h ${minutes}m`
  if (minutes > 0) return `${minutes}m ${seconds}s`
  return `${seconds}s`
}

export const statusColor = (run) => {
  if (!run) return 'default'
  if (run.status === 'running') return 'info'
  if (run.status === 'cancelled') return 'default'
  if (run.status === 'failed') return 'error'
  if (run.status === 'completed' && (run.locations_failed || 0) > 0) return 'warning'
  if (run.status === 'completed') return 'success'
  return 'default'
}

export const statusLabel = (run) => {
  if (!run) return 'None'
  if (run.status === 'completed' && (run.locations_failed || 0) > 0) {
    return 'Completed (partial)'
  }
  if (run.status === 'running' && run.possibly_stuck) return 'Possibly stuck'
  if (run.status === 'running' && run.cancel_requested_at) return 'Stopping…'
  if (run.status === 'running') return 'Running'
  if (run.status === 'cancelled') return 'Cancelled'
  if (run.status === 'failed') return 'Failed'
  if (run.status === 'completed') return 'Completed'
  return run.status
}

export const triggerLabel = (run) => {
  if (!run?.trigger) return '—'
  if (run.trigger === 'cron') return 'Cron'
  if (run.trigger === 'manual') return 'Manual'
  return run.trigger
}

/**
 * Admin-facing configured automatic schedule. Prefer the API interval so a
 * future config change does not contradict a hardcoded banner.
 */
export const promotionSyncCronScheduleMessage = (schedule) => {
  const minutes = Number(schedule?.interval_minutes)
  if (Number.isFinite(minutes) && minutes > 0) {
    const hours = Math.floor(minutes / 60)
    const rem = minutes % 60
    const parts = []
    if (hours > 0) parts.push(`${hours} hour${hours === 1 ? '' : 's'}`)
    if (rem > 0) parts.push(`${rem} minute${rem === 1 ? '' : 's'}`)
    if (parts.length > 0) {
      return `Promotion Sync Cron Schedule: Every ${parts.join(' and ')}.`
    }
  }
  if (typeof schedule?.schedule === 'string' && schedule.schedule.trim()) {
    return `Promotion Sync Cron Schedule: ${schedule.schedule.trim()}.`
  }
  return 'Promotion Sync Cron Schedule: Every 4 hours and 30 minutes.'
}
